'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('../../../../../../_virtual/index.cjs');
require('react');
require('@remix-run/react');
require('react-router-dom');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
var InternalTextInput_web = require('../../internal/InternalTextInput/InternalTextInput.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');
var InternalInputIcon_web = require('../../internal/InternalInputIcon/InternalInputIcon.web.cjs');

/**
 * TextInput component is used to display a text input field
 * Includes validation for required onBlur
 *
 * {@link https://aviary.fullscript.io/latest/components/text-input/web-IrkYioSL-IrkYioSL | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/TextInput/TextInput.web.tsx| View in GitLab}
 *
 * @scope Core
 */ const TextInput = ({ type = "text", tooltipContent, maxLength, onChange, ...rest })=>{
    const handleChange = (e)=>{
        let currentValue = e.target.value;
        if (type === "number" && maxLength) {
            currentValue = currentValue.slice(0, maxLength).replace(/\D/g, "");
        }
        if (onChange) {
            const event = {
                ...e,
                target: {
                    ...e.target,
                    value: currentValue
                }
            };
            onChange(event);
        }
    };
    return /*#__PURE__*/ jsxRuntime.jsx(InternalTextInput_web.InternalTextInput, {
        "data-testid": "aviary-text-input",
        type: type,
        rightContent: tooltipContent && /*#__PURE__*/ jsxRuntime.jsx(InternalInputIcon_web.InternalInputIcon, {
            icon: "info",
            "aria-label": "More information",
            tooltipContent: tooltipContent
        }),
        onChange: handleChange,
        maxLength: maxLength,
        inputMode: type === "number" ? "numeric" : "text",
        ...rest
    });
};

exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.web.cjs.map
